import type { ActionParams } from '@swf/components/StarsMPNotification/config/NotificationTypes';
import { dispatch } from '@swf/core/store';

import defaultHeaderImg from '../../assets/images/default-header.png';
import FixedPrizeDrawBack from '../../components/FixedPrizeDraw/FixedPrizeDrawBack';
import FixedPrizeDrawLost from '../../components/FixedPrizeDraw/FixedPrizeDrawLost';
import { ActionType } from '../../enums';

import {
  TXTCLI_Close,
  TXTWCL_Better_luck_next_timeX,
  TXTWCL_Check_the_Prizes,
  TXTWCL_The_N0_took_place_on_N1X_but_u_ELL,
  TXTWCL_Winners
} from './FixedPrizeDraw.Lost.messages.json';

export default {
  front: {
    view: FixedPrizeDrawLost,
    viewConfig: {
      title: { tag: TXTWCL_Better_luck_next_timeX },
      description: {
        tag: TXTWCL_The_N0_took_place_on_N1X_but_u_ELL,
        values: { 0: 'title', 1: 'formattedDrawDate' }
      },
      defaultHeaderImageURL: defaultHeaderImg,
      showCloseIcon: true,
      actions: [
        {
          actionType: ActionType.Primary,
          actionLabel: { tag: TXTCLI_Close },
          actionFunction: ({ notificationId }: ActionParams) => {
            dispatch.notification.delete({ notificationId });
            dispatch.modal.close('/mpnotifications');
          }
        },
        {
          actionType: ActionType.Secondary,
          actionLabel: { tag: TXTWCL_Check_the_Prizes },
          actionFunction: () => {
            /* handled in NotificationComponent secondary action */
          }
        }
      ]
    }
  },
  back: {
    view: FixedPrizeDrawBack,
    viewConfig: {
      title: { tag: TXTWCL_Winners }
    }
  }
};
